import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { useAuthStore } from "@/store/auth";
import type { Meta, Paged, Picklist, Service, User, UserBrief } from "@/types";

const stable = { staleTime: 5 * 60_000 };

export function useMeta() {
  return useQuery({
    queryKey: ["meta"],
    queryFn: async () => (await apiClient.get<Meta>("/meta/")).data,
    ...stable,
  });
}

export function useUsers() {
  return useQuery({
    queryKey: ["users"],
    queryFn: async () => (await apiClient.get<(User | UserBrief)[]>("/users/")).data,
    ...stable,
  });
}

export function useServices() {
  return useQuery({
    queryKey: ["services"],
    queryFn: async () => (await apiClient.get<Service[]>("/services/")).data,
    ...stable,
  });
}

export function useSources() {
  return useQuery({
    queryKey: ["sources"],
    queryFn: async () => (await apiClient.get<Picklist[]>("/sources/")).data,
    ...stable,
  });
}

export function useLossReasons() {
  return useQuery({
    queryKey: ["loss-reasons"],
    queryFn: async () => (await apiClient.get<Picklist[]>("/loss-reasons/")).data,
    ...stable,
  });
}

export function useMe(): User {
  return useAuthStore.getState().user as User;
}

export function useCurrentUser(): User | null {
  return useAuthStore((s) => s.user);
}

export async function fetchList<T>(url: string, params?: object): Promise<T[]> {
  const res = await apiClient.get<Paged<T> | T[]>(url, { params: { page_size: 500, ...params } });
  return Array.isArray(res.data) ? res.data : res.data.results;
}

export const VERTICAL_LABEL: Record<string, string> = {
  study_abroad: "Study Abroad",
  local_education: "Local Education",
};
